import html2canvas from "html2canvas";

export const copyImageToClipboard = async (element: HTMLElement): Promise<void> => {
  if (!navigator.clipboard || !window.ClipboardItem) {
    return Promise.reject(new Error("API de Clipboard não suportada neste navegador."));
  }

  try {
    const canvas = await html2canvas(element);

    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, "image/png")
    );

    if (!blob) {
      throw new Error("Falha ao criar o blob da imagem.");
    }

    const clipboardItem = new ClipboardItem({ "image/png": blob });
    await navigator.clipboard.write([clipboardItem]);

  } catch (error) {
    console.error("Erro ao copiar imagem para a área de transferência:", error);
    return Promise.reject(error);
  }
};
